import { ValidityPeriodTypeCode } from '~/__generated__/__types__'
import { toISOByDateFormat } from '~/app/utils/datetime'
import { DateTime } from 'luxon'

const fbq = global['fbq']

type EventName = 'InitiateCheckout' | 'Purchase'

export const FbqInitiateCheckoutDataContentType = {
  PROPERTY: 'hotel',
  LEISURE: 'product',
  TRAIN: 'd_tr',
  BUS: 'd_bus',
}

export type TFbqInitiateCheckoutDataContentType =
  (typeof FbqInitiateCheckoutDataContentType)[keyof typeof FbqInitiateCheckoutDataContentType]

export interface IFbqInitiateCheckoutData {
  content_type: TFbqInitiateCheckoutDataContentType
  checkin_date?: string
  checkout_date?: string
  content_ids: string
  city: string
  region: string
  country?: string
  num_adults: number
  num_children: number
}

export interface IFbqPurchaseData extends IFbqInitiateCheckoutData {
  value: number
  currency: 'KRW'
}

export const getFbqLeisureProductCheckInOutDate = (variant, currentAt) => {
  return {
    checkin_date:
      variant.validityPeriodTypeCode === ValidityPeriodTypeCode.Fix
        ? toISOByDateFormat(variant.validityStartDateTime, 'yyyy-MM-dd HH:mm')
        : toISOByDateFormat(
            DateTime.fromISO(currentAt).plus({ days: +!variant.isAvailableOnPurchaseDate }).toISO()
          ),
    checkout_date:
      variant.validityPeriodTypeCode === ValidityPeriodTypeCode.Fix
        ? toISOByDateFormat(variant.validityEndDateTime, 'yyyy-MM-dd HH:mm')
        : toISOByDateFormat(
            DateTime.fromISO(currentAt).plus({ days: variant.validityDays }).toISO()
          ),
  }
}

export const trackFbq = (
  eventName: EventName,
  data: IFbqInitiateCheckoutData | IFbqPurchaseData
): void => {
  if (!fbq) {
    return
  }

  // country property default 값은 '한국'. 해외숙소의 경우 country 를 data 에 포함시켜줘야함
  const sendingData = { country: '한국', ...data }
  if (process.env.NODE_ENV === 'development') {
    console.table({ event: 'Facebook Pixel', eventName, ...sendingData })
    return
  }

  fbq('track', eventName, sendingData)
}
